"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const usePortal = (id, children) => {
    const [element, setElement] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        let target = document.querySelector(`#${id}`) || document.querySelector(`.${id}`);
        if (!target) {
            target = document.createElement('div');
            target.id = id;
            document.body.append(target);
        }
        setElement(target);
    }, [id]);
    if (element) {
        return react_dom_1.default.createPortal(children, element);
    }
    return null;
};
exports.default = usePortal;
